import { render, staticRenderFns } from "./empty-layout.vue?vue&type=template&id=290c21d6&"
import script from "./empty-layout.vue?vue&type=script&lang=js&"
export * from "./empty-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports